export enum ApplePayPage {
    PRODUCT_PAGE = "product-page",
    CART_PAGE = "cart-page",
    CHECKOUT_PAGE = "checkout-page",
}
